import { UserDetail } from './models/user-details.model';
import { User } from './models/user.model';
import { environment } from '../environments/environment';

export const appVersion = "1.0.0";
 
export const appName = "Heralp Insight";
export const appCode = "Heralp Insight";
export const appDev = `${environment.baseUrl}/dashboard`;
 
export let isAndroid: boolean[] = [false];
export let isIos: boolean[] = [false];
export let isBrowser: boolean[] = [false];
export let isAndroidWebView: boolean[] = [false];
export let isIosWebView: boolean[] = [false];

//Oturum Açan Kullanıcı Bilgilerini Tutar
export const account: { token?: string, type?: number, username?: string, password?: string, cookie?: string, userData?: User, userDetail?: UserDetail, rememberMe?: boolean} = {
    token: '',
    username: 'admin',
    password: 'admin',
    type: 0,
    userData: new User(),
    userDetail: new UserDetail(),
    rememberMe: false
};

export let GeneralSettings: { url: string,  dil: string, kurumKodu: string, kurumAdi?: string, logo?: any} = {
    url: '',
    dil: 'tr', 
    kurumAdi: "",
    kurumKodu: '',
    logo: null, 
}